/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import {
    BANNER_IMPRESSION_EVENT, OFFER_INBOX_IMPRESSION_GROUP, buildOfferInboxBannerEvent, getOfferName,
} from './offerInboxTracking';

// fires one banner_impression per mounted offer, only once the offer actually renders (isRendered)
// and only when there is a name to report; itemName overrides the offer name (e.g. 'Exit Intent')
const useOfferInboxImpression = (offer, isRendered = true, itemName = '') => {
    const dispatch = useDispatch();
    const isImpressionFired = useRef(false);

    useEffect(() => {
        const bannerItemName = itemName || getOfferName(offer);
        if (!isRendered || !offer || !bannerItemName || isImpressionFired.current) return;
        isImpressionFired.current = true;
        dispatch(trackEvent(buildOfferInboxBannerEvent({
            eventName: BANNER_IMPRESSION_EVENT,
            bannerGroup: OFFER_INBOX_IMPRESSION_GROUP,
            bannerItemName,
        })));
    }, [isRendered, offer, itemName]);
};

export default useOfferInboxImpression;
